import React from 'react';
import './style.css'
import {useAppSelector} from "../../common/hook";

export const SuccessfulRestorePassword = () => {

    const message = useAppSelector(state => state.resetPasswordEmail.message);
    const title = message.title;
    const text = message.text;



    return (
        <div className='registration-container'>
            <div className='successful-registration'>
                <p className='registration-title'>{title}</p>
                <span className='registration-text'>
                   {text}
                </span>
            </div>
        </div>
    );
};